
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([background-color='white']) slot[name='top-content'],
  :host([background-color='white']) slot[name='bottom-content'],
  :host([background-color='white']) slot[name='title']{
    color:var(--brand-primary-1);
  }
  :host([background-color='white']) slot[name='search']{
    display:flex;
    border:2px solid var(--gray-600);
  }
  @media (min-width: 768px){
  :host([background-color='white']) slot[name='search']{
      width:-moz-fit-content;
      width:fit-content
  }
    }

:host([background-color='primary-1']) slot[name='top-content'],
  :host([background-color='primary-1']) slot[name='bottom-content'],
  :host([background-color='primary-1']) slot[name='title']{
    color:var(--brand-neutral-white);
  }

:host([background-color='primary-1']) slot[name='search']{
    display:flex;
    border:2px solid var(--brand-primary-1);
  }

@media (min-width: 768px){

:host([background-color='primary-1']) slot[name='search']{
      width:-moz-fit-content;
      width:fit-content
  }
    }

:host([variant='hero']) slot[name='search']{
    max-width:100%;
  }

@media (min-width: 768px){

:host([variant='hero']){
    position:relative;
    top:-50px
}

    :host([variant='hero']) slot[name='search']{
      max-width:auto;
    }
  }

.se-search{
  display:flex;
  width:100%;
}

.se-search--content{
  position:relative;
  display:flex;
  margin:0 auto;
  flex-direction:column;
  min-height:470px;
  justify-content:center;
  width:100%;
  z-index:1;
  row-gap:1.25rem;
  padding:4rem 0;
}

@media (min-width: 1660px){

.se-search--content{
    max-width:1660px
}
  }

@media (min-width: 1440px) and (max-width: 1660px){

.se-search--content{
    max-width:1440px
}
  }

@media (min-width: 1330px) and (max-width: 1440px){

.se-search--content{
    max-width:1330px
}
  }

@media (min-width: 1280px) and (max-width: 1330px){

.se-search--content{
    max-width:1280px
}
  }

@media (min-width: 1024px) and (max-width: 1280px){

.se-search--content{
    max-width:1024px
}
  }

@media (min-width: 768px) and (max-width: 1023px){

.se-search--content{
    max-width:768px
}
  }

@media (max-width: 767px){

.se-search--content{
    min-height:0 !important;
    padding:2rem 0;
    margin:0 1rem
}
  }

.se-search--content.is-nav{
    min-height:540px;
  }

.se-search--content.is-hero{
    min-height:400px;
  }

@media (min-width: 768px){

.se-search--content.is-hero{
      width:auto !important
  }
    }

:host([variant='nav']) .se-search--wrapper{
    right:0px;
    top:0px;
    z-index:4;
    position:absolute;
    left:0px;
    width:100%;
  }

.se-search--wrapper{
  width:100%;
  z-index:4;
}

.top-right{
  position:absolute;
  right:0;
  top:20px;
  z-index:4;
}

slot[name='top-content']{
  display:block;
  margin-bottom:0;
  font-size:var(--fs-lg-mobile);
  font-family:var(--ff-dmsans);
}

@media (min-width: 768px){

slot[name='top-content']{
    font-size:var(--fs-lg);
    margin-bottom:3rem
}
  }

@media (min-width: 768px){

slot[name='top-content']{
    max-width:40%
}
  }

slot[name='bottom-content']{
  display:block;
  width:100%;
  padding:0 1rem;
}

@media (min-width: 768px){

slot[name='bottom-content']{
    width:700px;
    padding:0
}
  }

se-container{
  width:100%;
}
`;